import React  from 'react'
import {compose, setDisplayName, withHandlers, withPropsOnChange } from "recompose";
import { ifElse, always, equals } from "ramda";
import {connect} from "react-redux";

import { nextDropdown } from '../../../../../../actions/dropdown'
import { DropdownMenu } from "../../../../../Shared/DropdownMenu/DropdownMenu";

import './Chapters.css'
import {getLocaleString} from "../../../../../../locale";

import { Scrollbars } from 'react-custom-scrollbars';

const DROPDOWN_ID = 'CHAPTERS'
const isActive = equals(DROPDOWN_ID)

const toggleMenu = ({activeDropdown, nextDropdown}) => ({isInner = false}) => ifElse(
  equals(true),
  () => nextDropdown(null),
  () => ifElse(
    equals(false),
    () => nextDropdown(DROPDOWN_ID),
    always(null)
  )(isInner)
)(isActive(activeDropdown))

const mapStateToProps = state => ({
  activeDropdown: state.activeDropdown,
  chapters: state.reader.chapters,
  currChapter: state.reader.currChapter
})

const mapDispatchToProps = (dispatch) => ({
  nextDropdown: (id) => dispatch(nextDropdown(id))
})

const handlers = withHandlers({
  toggleMenu
})

export const enhance = compose(
  setDisplayName('Chapters'),
  connect(mapStateToProps, mapDispatchToProps),
  withPropsOnChange(['activeDropdown'], ({activeDropdown}) => ({
    active: isActive(activeDropdown)
  })),
  handlers
)

const ChapterList = ({chapters, onChangeChapter, toggleChapter, chapterOpen, toggleMenu, currChapter}) => (
  <ul className="chapters">
    {chapters.length > 0 ? chapters.map((chapter, index) =>
      <ChapterItem key={index} chapter={chapter} index={index} onChangeChapter={onChangeChapter}
                   toggleChapter={toggleChapter} chapterOpen={chapterOpen} toggleMenu={toggleMenu}
                   currChapter={currChapter}/>
    ) : ''}
  </ul>
)

const isChapterActive = (opened, curr) => {
  return opened.indexOf(curr) > -1 ? ' active' : ''
}

const isChapterSelected = (opened, curr) => {
  return opened.indexOf(curr) > -1 ? ' selected' : ''
}

const ChapterItem = ({chapter, index, onChangeChapter, toggleChapter, chapterOpen, toggleMenu, currChapter}) => {
  let withSubitems = chapter.subitems.length > 0

  return <li id={`chapter-${index}`} className={`chapter-item${isChapterSelected(currChapter, chapter.href.chapterIndex)}`} data-id={chapter.href.chapterIndex}>
    <span className="chapter-item-label with-cursor">
      {withSubitems ?
        <i className={`chapter-arrow${isChapterActive(chapterOpen, 'chapter-'+index)}`}
           onClick={() => toggleChapter('chapter-'+index)}></i>
        : ''}
      <span onClick={() => {toggleMenu(false); onChangeChapter(chapter.href)}}>{chapter.label}</span>
      <span className="chapter-item-page" onClick={() => {toggleMenu(false); onChangeChapter(chapter.href)}}>{chapter.page ? chapter.page : ''}</span>
    </span>
    {withSubitems ?
      <ul className={`chapters-sub${isChapterActive(chapterOpen, 'chapter-'+index)}`}>
        {chapter.subitems.length > 0 ? chapter.subitems.map((subitem, subIndex) =>
          <ChapterSubItem key={subIndex} index={subIndex} chapterOpen={chapterOpen} subitem={subitem} onChangeChapter={onChangeChapter} toggleMenu={toggleMenu}
                          toggleChapter={toggleChapter} parentIndex={'chapter-'+index} currChapter={currChapter}/>) : ''}
      </ul>
      : ''}
  </li>
}

const ChapterSubItem = ({subitem, onChangeChapter, toggleMenu, chapterOpen, index, parentIndex, toggleChapter,
                          currChapter}) => {
  let withSubitems = subitem.subitems.length > 0

 return <li className={`chapter-subitem${isChapterSelected(currChapter, subitem.href.chapterIndex)}`} data-id={subitem.href.chapterIndex}>
    <span className="chapter-subitem-label">
      {withSubitems ?
        <i className={`chapter-arrow${isChapterActive(chapterOpen, parentIndex+'-'+index)}`}
           onClick={() => toggleChapter(parentIndex+'-'+index)}></i>
        : ''}
      <span onClick={() => {toggleMenu(false); onChangeChapter(subitem.href)}}>{subitem.label}</span>
      <span className="chapter-subitem-page" onClick={() => {toggleMenu(false); onChangeChapter(subitem.href)}}>{subitem.page ? subitem.page : ''}</span>
    </span>
   { withSubitems ?
      <ul className={`chapters-sub${isChapterActive(chapterOpen, parentIndex+'-'+index)}`}>
        {subitem.subitems.length > 0 ? subitem.subitems.map((child, childIndex) =>
          <ChapterSubItem key={childIndex} index={childIndex} subitem={child} onChangeChapter={onChangeChapter} toggleChapter={toggleChapter}
                          chapterOpen={chapterOpen} toggleMenu={toggleMenu} parentIndex={parentIndex+'-'+index} currChapter={currChapter}/>) : ''}
      </ul>
     : ''}
  </li>
}

export class View extends React.Component {
  constructor(props) {
    super(props)

    this.state = {chapterOpen: ''}
    this.toggleChapter = this.toggleChapter.bind(this)
  }

  toggleChapter(id) {
    let chapter = ''
    if (id === this.state.chapterOpen) {
      if (id.split('-').length > 2) {
        id = id.split('-')
          .slice(0, -1)
        chapter = id.join('-')
      } else {
        chapter = id === this.state.chapterOpen ? '' : id
      }
    } else if (this.state.chapterOpen.indexOf(id) > -1) {
      id = id.split('-')
        .slice(0, -1)
      chapter = id.join('-')
    } else {
      chapter = id
    }

    this.setState({'chapterOpen': chapter})
  }

   render() {
     const {props: {toggleMenu, active, onChangeChapter, chapters, currChapter}} = this

     return (
       <div className="Chapters__wrap">
         <button className="chapters-btn icon-btn" onClick={toggleMenu} data-active={active}></button>
         <DropdownMenu active={active}>
           <div className="Chapters__header Dropdown__header">
             <span className="Chapters__header-text">{getLocaleString('reader.chaptersTitle')}</span>
             <button className="btn btn-close-white icon-btn" onClick={toggleMenu} data-active={active}></button>
           </div>
           <div className="Chapters__content limit-content-height">
             <Scrollbars style={{ width: 315, height: 432 }}
                         renderTrackHorizontal={props => <div {...props} style={{display: 'none'}} className="track-horizontal"/>}
             >
              <ChapterList chapters={chapters} onChangeChapter={onChangeChapter} toggleChapter={this.toggleChapter}
                          chapterOpen={this.state.chapterOpen} toggleMenu={toggleMenu} currChapter={currChapter}/>
             </Scrollbars>
           </div>
         </DropdownMenu>
       </div>
     )
   }
}

export const Chapters = enhance(View)


// WEBPACK FOOTER //
// ./src/components/Reader/components/Navigation/components/Chapters/Chapters.js